import service from '@/utils/server';

const modName='/bd/loginLog/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'exportData',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/log/loginLog/api/index.js